import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Batch from './Batch';
import BatchUploadErrors from './Batch/errors';

const Order = () => {
  const [batchUploadErrors, setBatchUploadErrors] = useState([]);
  return (
    <div className={'Order-Root padding-page-content'}>
      <Grid container spacing={1}>
        <Grid className={'Order-HorizontalPane'} size={12}>
          <Grid container spacing={1} direction="column">
            <Grid className={'Order-VerticalPane'} size={12}>
              <Batch setErrors={setBatchUploadErrors} />
            </Grid>
            <Grid className={'Order-VerticalPane'} size={12}>
              <BatchUploadErrors uploadErrors={batchUploadErrors} />
            </Grid>
            <Grid className={'Order-VerticalPane'} size={12} />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Order;